export const SET_FARMING_CONTRACT_STEP = "SET_FARMING_CONTRACT_STEP";
export const UPDATE_FARMING_CONTRACT = "UPDATE_FARMING_CONTRACT";
export const ADD_FARMING_SETUP = "ADD_FARMING_SETUP";
export const REMOVE_FARMING_SETUP = "REMOVE_FARMING_SETUP";
export const ADD_INFLATION_SETUP = "ADD_INFLATION_SETUP";
export const REMOVE_INFLATION_SETUP = "REMOVE_INFLATION_SETUP";
export const SET_INFLATION_CONTRACT_STEP = "SET_INFLATION_CONTRACT_STEP";
export const UPDATE_INFLATION_CONTRACT = "UPDATE_INFLATION_CONTRACT";
export const ADD_ENTRY = "ADD_ENTRY";
export const REMOVE_ENTRY = "REMOVE_ENTRY";